// Copyright (c) 2025 Goffy. This file belongs to Goffy. All Rights Reserved.

import { useRoundState } from '@/stores/roundState';

const STORAGE_KEY = 'goffy:current-tour';
let memoryTourId: string | null = null;

const getStorage = () => (typeof window !== 'undefined' ? window.localStorage : null);

export function setCurrentTourId(tourId: string | null, options?: { preserveRound?: boolean }) {
  const current = getCurrentTourId();
  if (tourId && tourId !== current && !options?.preserveRound) {
    const roundState = useRoundState.getState();
    roundState.setRoundAndHole(null, null);
  }
  memoryTourId = tourId;
  const storage = getStorage();
  if (!storage) return;
  if (tourId) {
    storage.setItem(STORAGE_KEY, tourId);
  } else {
    storage.removeItem(STORAGE_KEY);
  }
}

export function getCurrentTourId(): string | null {
  const storage = getStorage();
  if (!storage) return memoryTourId;
  return storage.getItem(STORAGE_KEY) ?? memoryTourId;
}
